import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hotelSearch, setIsUserInteractedWithHotelList } from '../../../../store/slices/hotel';
import Pagination from '../../../Pagination';
import LoadMoreHotelsButton from './LoadMoreHotelsButton';

const HotelPagination = ({ tripId, className }) => {
  const hotelSearchState = useSelector((store) => store.hotel.hotelSearches[tripId]);
  const responses = useSelector((state) => state.hotel.hotelSearchResponses);
  const [response, setResponse] = useState(null);
  const dispatch = useDispatch();

  // TODO: useCallback?
  useEffect(() => {
    if (hotelSearchState && responses) {
      setResponse(responses[hotelSearchState.queryString]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hotelSearchState]);

  const handleNextPageClick = () => {
    dispatch(setIsUserInteractedWithHotelList(true));
    const { page, pageSize } = hotelSearchState.searchObj;
    const { totalHotels } = response;
    const p = (page * pageSize) + (totalHotels % pageSize) > totalHotels ? page : page + 1;

    if (p > page) {
      dispatch(hotelSearch({
        tripId,
        searchObj: {
          page: p,
        },
      }));
    }
  };

  const handlePrevPageClick = () => {
    const { page } = hotelSearchState.searchObj;
    const p = page - 1 > 0 ? page - 1 : page;
    dispatch(setIsUserInteractedWithHotelList(true));
    if (p < page) {
      dispatch(hotelSearch({
        tripId,
        searchObj: {
          page: p,
        },
      }));
    }
  };

  return (hotelSearchState
    && (
      <>
        {response && (
          <LoadMoreHotelsButton
            tripId={tripId}
            totalHotels={response.totalHotels}
            foundTotalHotels={hotelSearchState.foundTotalHotels}
            className="mt-2"
          />
        )}
        <div className={className}>
          <Pagination
            page={hotelSearchState.searchObj.page}
            pageSize={hotelSearchState.searchObj.pageSize}
            totalCount={(response || {}).totalHotels}
            onPrevPageClick={handlePrevPageClick}
            onNextPageClick={handleNextPageClick}
            resultsLabel="hotels"
          />
        </div>
      </>
    )
  );
};

HotelPagination.propTypes = {
  tripId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

HotelPagination.defaultProps = {
  className: undefined,
};

export default HotelPagination;
